export const UPDATE_CANVAS_DATA_PARAM = 'UPDATE_CANVAS_DATA_PARAM';
export const SAVE_CANVAS_SETTINGS = 'SAVE_CANVAS_SETTINGS';
